<template>
    <b-modal :id="`common-image-cropper-modal-${cropperModalId}`" class="base-modal" @show="onShow" @hide="onHidden"
        centered no-close-on-esc no-close-on-backdrop>
        <img ref="image" :src="source" id="preview-image" class="img-fluid" alt="Preview" />
        <template slot="modal-footer">
            <div class="d-flex align-items-center">
                <div class="slider-container">
                    <img src="@/assets/images/icons/panorama.svg" class="h-75" alt="Panorama">
                    <b-input v-model="zoomValue" type="range" min="0" step="0.1" max="1" class="zoom-range"></b-input>
                    <img src="@/assets/images/icons/panorama.svg" alt="Panorama">
                </div>
                <b-button variant="link" class="action-button mx-2" @click="downloadImage">
                    <img src="@/assets/images/icons/crop-download.svg" class="h-75" alt="Download">
                </b-button>
                <b-button variant="link" class="action-button" @click="deleteImage">
                    <img src="@/assets/images/icons/garbage-can.svg" class="h-75" alt="Clear">
                </b-button>
            </div>
            <b-button variant="primary" @click="cropImage" class="px-5">Crop</b-button>
        </template>
    </b-modal>
</template>

<script>
import Cropper from "cropperjs";

export default {
    props: {
        source: {
            type: String,
            default: ""
        },
        aspectRatio: {
            type: String,
            default: null
        },
        cropperModalId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            cropper: null,
            croppedImage: null,
            zoomValue: 0.5,
        }
    },
    methods: {
        onShow() {
            this.cropper = new Cropper(this.$refs.image, {
                zoomOnWheel: false,
                zoomOnTouch: false,
                aspectRatio: this.aspectRatio && this.aspectRatio === "square" ? 1 : 16 / 9,
                center: false,
                viewMode: 1,
                minCropBoxHeight: 48
            });
        },
        onHidden() {
            this.cropper.destroy();
            this.cropper = null;
            this.croppedImage = null;
            this.zoomValue = 0.5;
            document.body.classList.remove("modal-open");
        },
        deleteImage() {
            this.$emit("onDeleteImage");
            this.$root.$emit("bv::hide::modal", `common-image-cropper-modal-${this.cropperModalId}`);
        },
        processCropping() {
            const type = this.source.substring("data:".length, this.source.indexOf(";base64"));
            this.croppedImage = this.cropper.getCroppedCanvas().toDataURL(type);
        },
        cropImage() {
            this.processCropping();
            this.$emit("onCropImage", this.croppedImage);
            this.$root.$emit("bv::hide::modal", `common-image-cropper-modal-${this.cropperModalId}`);
        },
        downloadImage() {
            this.processCropping();
            const fileExtension = `.${this.source.substring('data:image/'.length, this.source.indexOf(';base64'))}`;
            const a = document.createElement("a");
            a.href = this.croppedImage;
            a.download = `${Date.now()}${fileExtension}`;
            a.click();
        }
    },
    watch: {
        zoomValue(newValue, oldValue) {
            if (this.cropper)
                this.cropper.zoom(Math.round((newValue - oldValue) * 10) / 10);
        }
    }
}
</script>

<style lang="scss">
div[id^="common-image-cropper-modal-"] {
    .close {
        color: #1C1B1F;
    }

    .modal-content {
        border-radius: 12px;
    }

    .modal-body {
        padding: 0;
    }

    .modal-dialog {
        max-width: 683px;
        max-height: 579px;
    }

    .modal-footer {
        justify-content: space-between;
    }

    .slider-container {
        width: 298px;
        height: 35px;
        border: 1px solid #EDF2F8;
        border-radius: 6px;
        padding: 10px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;

        .zoom-range {
            width: 218px;
        }
    }

    .action-button {
        border: 1px solid #EDF2F8;
        border-radius: 6px;
        min-width: 35px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>